import angular from 'angular';
import constants from 'app/constants';
import {
  amSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import validator, { name as validatorName } from './messages/agency-unique-name.validator.directive';
import controller from './add-audit-agency-dialog.controller';
import messageTpl from './messages/agency.name.messages.html';
import template from './add-audit-agency-dialog.html';


class dialogService {
  getOptions($event, {
    customerId,
    audit,
    agency,
    agencies,
    auditTypes,
    coordinators,
    dataTypes,
    refreshAudit,
    addCallback,
    updateCallback,
  }) {
    return {
      controller,
      controllerAs: 'addAuditAgencyDialogVM',
      locals: {
        customerId,
        audit,
        agency,
        agencies,
        auditTypes,
        coordinators,
        dataTypes,
        refreshAudit,
        addCallback,
        updateCallback, // provided for legacy event system
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.addAuditAgencyDialog', [
  alerts,
  amSharedModelService,
  constants,
  loaderService,
  ssDialogService,
])
  .directive(validatorName, validator)
  .service('addAuditAgencyDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('agency.name.messages.html', messageTpl);
  })
  .name;
